import { Directive, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive()
export abstract class ExtensibleControlValueAccessor implements ControlValueAccessor {
  @Input() required: boolean = false;

  value: any = null;
  onChange: any = () => {};
  onTouch: any = () => {};

  writeValue(val: any) {
    this.value = val;
  }
  registerOnChange(fn) {
    this.onChange = fn;
  }
  registerOnTouched(fn) {
    this.onTouch = fn;
  }
  constructor() {}
}
